var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoMarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125.56 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D7DDD",
    d: "M12.59,7.31V35.16a14.52,14.52,0,0,0,7.25,12.56L138.1,116V79.77Z",
    transform: "translate(-12.59 -7.31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0082CA",
    d: "M49.38,131h-.06a3.54,3.54,0,0,1-1.74.47,3.6,3.6,0,0,1-2-.61h0l29.79,17.2h0l0,0a7.27,7.27,0,0,0,7.21,0L138.15,116V79.77Z",
    transform: "translate(-12.59 -7.31)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5FD0DF",
    d: "M47.58,131.48a3.54,3.54,0,0,0,1.74-.47h.06l26-15V79.77L51.27,93.69A14.51,14.51,0,0,0,44,106.26v21.66h0a3.54,3.54,0,0,0,1.51,2.9l0,.05h0A3.6,3.6,0,0,0,47.58,131.48Z",
    transform: "translate(-12.59 -7.31)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMarkDark);
export default __webpack_public_path__ + "static/media/logo-mark-dark.8cf26120b017cf99453c7a5b4bd50972.svg";
export { ForwardRef as ReactComponent };